export const getAttachmentIcon = (contentType?: string) => {
  switch (contentType) {
    case "application/pdf":
      return "file-pdf";
    case "application/msword":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "file-doc";
    case "application/vnd.ms-powerpoint":
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "file-ppt";
    case "application/vnd.ms-excel":
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "file-xls";
    case "application/vnd.oasis.opendocument.text":
      return "file-odt";
    case "application/vnd.oasis.opendocument.presentation":
      return "file-odp";
    case "application/vnd.oasis.opendocument.spreadsheet":
      return "file-ods";
    case "image/jpeg":
      return "file-jpg";
    case "image/png":
      return "file-png";
    case "application/acad":
    case "image/x-dwg":
    case "image/vnd.dwg":
    case "application/octet-stream":
      return "file-dwg";
    default:
      return "file";
  }
};
